import React from "react";
import ViewWinnerTableComponent from "./viewWinnerTable.component";

export default function ViewWinnerTableContainer({ data, lang }) {
  return <ViewWinnerTableComponent data={data} lang={lang}/>;
}
